module.exports = __webpack_public_path__ + "img/cover-default-image.02b05dda.png";